import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { VariantSizeSelectorComponent } from './variant-size-selector.component';

@NgModule({
  declarations: [VariantSizeSelectorComponent],
  imports: [CommonModule, RouterModule, UrlModule, I18nModule, MediaModule, MatTooltipModule],
  exports: [VariantSizeSelectorComponent],
})
export class VariantSizeSelectorModule {}
